//funcion para mostrar Iframe
function mostrarIframe(){
  $("button.fonttest-show-btn").hide();
  $("html").css("overflow", "hidden");
  $("div.fonttest-iframe-container").show();
}
//funcion para cerrar Iframe
function cerrarIframe(){
  $("button.fonttest-show-btn").show();
  $("html").css("overflow", "auto");
  $("div.fonttest-iframe-container").hide();
}
$(document).ready(function(){
  //revisar que exista el contenedor
  if ($("button.fonttest-show-btn").length != 0) {
    //agregar evento boton mostrar
    $("button.fonttest-show-btn").on("click", mostrarIframe);
    //agregar evento boton cerrar
    $("button.fonttest-close-btn").on("click", cerrarIframe);
  }

});
